import React from 'react';
import { useTable } from 'react-table';
import { Table, TableBodyCell, TableHeadCell, TableBodyRow, TableHeadRow, TableHead, TableBody } from '@blueprint/table';

// const columns = [
//     { Header: 'First Column', accessor: 'a' },
//     { Header: 'Second Column', accessor: 'b' },
//     { Header: 'Third Column', accessor: 'c' },
//     { Header: 'Fourth Column', accessor: 'd' },
// ];

// const data = [
//     { a: 1, b: 1, c: 1, d: 1 },
//     { a: 2, b: 2, c: 2, d: 2 },
//     { a: 3, b: 3, c: 3, d: 3 },
//     { a: 4, b: 4, c: 4, d: 42 },
// ];

export const DefaultTable = ({ data, columns }) => {
    console.log(columns);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ data, columns });
    return (
        <Table {...getTableProps()} width='100%'>
            <TableHead>
                {headerGroups.map((headerGroup) => (
                    <TableHeadRow {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((col) => {
                            return <TableHeadCell {...col.getHeaderProps()}>{col.render('Header')}</TableHeadCell>;
                        })}
                    </TableHeadRow>
                ))}
            </TableHead>
            <TableBody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                        <TableBodyRow {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                                return (
                                    <TableBodyCell
                                        {...cell.getCellProps()}
                                        textAlign={typeof cell.value === 'number' ? 'right' : 'left'}
                                        style={{ height: '-webkit-fill-available' }}
                                    >
                                        {cell.render('Cell')}
                                    </TableBodyCell>
                                );
                            })}
                        </TableBodyRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default DefaultTable;
